export const modal = {
  confirm: 'Konfimasi Ulang',
  confirm_content: 'Anda yakin melakukan perubahan # {id}?',
  edit: 'Edit post',
  create: 'Tambahkan post',
  export: 'Statistik ekspor',
  create_recording: 'Buat arsip catatan',
  warning: 'Perhatian',
  add_ip: 'Tambahkan IP',

  field: {
    search: {
      placeholder: 'Cari'
    }
  },

  confirmation: {
    recording: 'Apakah Anda yakin ingin mengekspor rekaman Anda?'
  }
};
